class CurrencyDetectCountryChange {
  constructor() {
    this.initialise()
  }

  async initialise() {
    await this.initialiseSessionStorage()
  }

  async initialiseSessionStorage() {
    if (sessionStorage.getItem('_currency_manually_set') === 'true') return

    if (!sessionStorage.getItem('_country_cache_value')) {
      const detectedCountry = await this.getBrowsingContextSuggestions()

      if (detectedCountry) {
        sessionStorage.setItem('_country_cache_value', detectedCountry)
      }
    } else {
      const detectedCountry = await this.getBrowsingContextSuggestions()

      const cachedCountry = sessionStorage.getItem('_country_cache_value')

      if (cachedCountry && detectedCountry && cachedCountry !== detectedCountry) {
        this.updateLocalisation(detectedCountry, window.Shopify.locale)
      }
    }
  }

  async getBrowsingContextSuggestions() {
    try {
      const suggestions = await fetch(
        window.Shopify.routes.root
          + 'browsing_context_suggestions.json'
          + '?country[enabled]=true'
          + '&language[enabled]=true'
      ).then(r => r.json());

      // Return detected country value based on the highest confidence suggestion
      if (suggestions.suggestions && suggestions.suggestions.length > 0) {
        const highestConfidenceSuggestion = suggestions.suggestions.reduce((prev, current) => {
          return (current.confidence > prev.confidence) ? current : prev
        })

        if (highestConfidenceSuggestion.parts?.country?.handle) {
          return highestConfidenceSuggestion.parts.country.handle
        }
      }
      
      return null
    } catch (error) {
      console.error('Error fetching browsing context suggestions:', error);
      return null
    }
  }

  updateLocalisation(countryCode, languageCode) {
    sessionStorage.removeItem('_country_cache_value')

    const formId = crypto.randomUUID();
    const formHtml = `
      <form id="${formId}" action="/localization" method="POST" hidden>
        <input name="_method" value="PUT" />
        <input name="country_code" value="${countryCode}" />
        <input name="language_code" value="${languageCode}" />
      </form>
    `;
    document.body.insertAdjacentHTML("beforeend", formHtml);
    document.getElementById(formId).submit();
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.BAO.CurrencyDetectCountryChange = new CurrencyDetectCountryChange()
  })
} else {
  window.BAO.CurrencyDetectCountryChange = new CurrencyDetectCountryChange()
}